export const INVENTORY_BUCKETS = {
	ECOMMERCE: 'ecommerce',
	VAREJO: 'varejo',
};

export const BUCKETS = [INVENTORY_BUCKETS.ECOMMERCE, INVENTORY_BUCKETS.VAREJO];

export const BUCKET_LABELS = {
	[INVENTORY_BUCKETS.ECOMMERCE]: 'E-commerce',
	[INVENTORY_BUCKETS.VAREJO]: 'Varejo',
};

const RETAIL_ORDER_SUBTYPE = 'varejo';

export const orderBucket = order =>
	order && order.subtype === RETAIL_ORDER_SUBTYPE
		? INVENTORY_BUCKETS.VAREJO
		: INVENTORY_BUCKETS.ECOMMERCE;

export const hasOrdersInConference = receivedOrders =>
	Boolean(receivedOrders && receivedOrders.orders && receivedOrders.orders.length);

export const getOpenBuckets = receivedOrdersByBucket =>
	BUCKETS.filter(bucket =>
		hasOrdersInConference(receivedOrdersByBucket && receivedOrdersByBucket[bucket])
	);

export const resolveActiveBucket = (openBuckets, chosenBucket) => {
	if (openBuckets.includes(chosenBucket)) {
		return chosenBucket;
	}
	return openBuckets.length === 1 && !chosenBucket ? openBuckets[0] : null;
};

export const receivedOrdersOfBucket = (bucket, receivedOrders) => {
	if (!receivedOrders) {
		return null;
	}
	const responseBucket = receivedOrders.bucket || INVENTORY_BUCKETS.ECOMMERCE;
	return responseBucket === bucket ? receivedOrders : null;
};
